import React from 'react';
import { EmailBadge, RetryButton, ContactLinks, isMissed, missedBorder, fmtDate, usd } from './Shared';

export const BookingCard = ({ b, onRetry, busy }) => (
  <div className={`bg-white border rounded-sm p-5 ${missedBorder(b.email_status)}`} data-testid={`admin-booking-${b.id}`}>
    <div className="flex flex-wrap items-start justify-between gap-3 mb-2">
      <div>
        <div className="font-display uppercase font-bold text-lg text-neutral-950">{b.service_name}</div>
        <div className="text-sm text-neutral-800 font-semibold">{b.start_at_local}</div>
        <div className="text-xs text-neutral-500">Requested {fmtDate(b.created_at)}</div>
      </div>
      <div className="flex items-center gap-3">
        <EmailBadge status={b.email_status} />
        {isMissed(b) && <RetryButton onClick={() => onRetry(b.id)} busy={busy} testId={`retry-booking-${b.id}`} />}
      </div>
    </div>
    <div className="text-sm text-neutral-900 font-semibold">{b.given_name} {b.family_name}</div>
    <ContactLinks phone={b.phone} email={b.email} />
    {b.service_address && <div className="text-sm text-neutral-700 mt-1">{b.service_address}, {b.service_city} {b.service_zip}</div>}
    {(b.addons || []).length > 0 && (
      <div className="text-xs text-neutral-600 mt-2">
        Add-ons: {b.addons.map((a) => `${a.group}${a.quantity > 1 ? ` ×${a.quantity}` : ''}`).join(', ')}
      </div>
    )}
    <div className="flex flex-wrap gap-x-5 gap-y-1 mt-3 text-xs text-neutral-600">
      <span>Total incl. tax: <b className="text-neutral-900">{usd(b.total_with_tax_cents || b.total_price_cents)}</b></span>
      <span>Deposit paid: <b className="text-green-700">{usd(b.deposit_paid_cents)}</b></span>
      <span>Balance due: <b className="text-red-600">{usd(b.balance_due_cents)}</b></span>
    </div>
    {b.customer_note && <p className="text-sm text-neutral-700 mt-2 italic">“{b.customer_note}”</p>}
  </div>
);
